import { ChevronDown, ExternalLink, FileText, Radio } from "lucide-react";
import { useState } from "react";
import { imagery } from "@/content";
import { Reveal } from "@/components/Reveal";

const videoSteps = [
  ["01", "Reconhecer a prisão", "Admitir que as bets deixaram de ser um jogo e passaram a controlar decisões."],
  ["02", "Entender o gancho", "Perceber como urgência, dopamina e quase-acertos mantêm o ciclo ativo."],
  ["03", "Quebrar o ciclo agora", "Bloquear aplicativos, fechar contas e procurar ajuda antes da próxima aposta."],
  ["04", "Proteger o dinheiro", "Separar contas, reduzir acesso e organizar uma saída das dívidas."],
  ["05", "Enfrentar a abstinência", "Atravessar ansiedade, tédio e gatilhos minuto a minuto, sem apostar."],
  ["06", "Reconstruir rotina", "Voltar ao sono, ao trabalho, ao exercício e à família com passos reais."],
];

export default function VideoSection() {
  const [transcript, setTranscript] = useState(false);

  return (
    <section className="section video-section" id="video-apresentacao" data-testid="virtual-ai-video-container">
      <div className="section-shell video-layout">
        <Reveal className="video-copy">
          <p className="eyebrow eyebrow-light">VÍDEO DE ABERTURA · 02:37</p>
          <h2>Um caminho claro para sair do ciclo.</h2>
          <p>Assista ao vídeo enviado para apresentar os primeiros passos do livro: reconhecer, proteger o dinheiro, enfrentar os gatilhos e reconstruir uma rotina mais segura.</p>
          <div className="ai-disclosure" data-testid="ai-video-disclosure"><Radio size={15} /><span>VÍDEO FORNECIDO PELO RESPONSÁVEL · Esta versão é uma apresentação narrada com slides; não mostra uma pessoa real nem deve ser tratada como depoimento.</span></div>
          <button className="text-button text-button-light" type="button" onClick={() => setTranscript(!transcript)} aria-expanded={transcript} data-testid="ai-video-transcript-drawer-toggle">{transcript ? "Fechar resumo" : "Ver resumo dos passos"} <ChevronDown size={16} className={transcript ? "turn" : ""} /></button>
          {transcript && <div className="transcript" data-testid="ai-video-transcript"><strong>Resumo do conteúdo narrado</strong><div className="transcript-segments">{videoSteps.map(([number, title, text]) => <div className="transcript-segment" key={number}><span>{number}</span><p><strong>{title}</strong>{text}</p></div>)}</div><a className="video-transcript-source" href={imagery.video} target="_blank" rel="noreferrer" data-testid="ai-video-source-link">Abrir arquivo original <ExternalLink size={13} /></a></div>}
        </Reveal>
        <Reveal className="video-player" delay={100}>
          <div className="video-stage" data-testid="ai-video-stage">
            <video controls preload="metadata" playsInline data-testid="ai-video-media-element" aria-label="Vídeo narrado sobre os passos para se libertar das bets">
              <source src={imagery.videoWebm} type="video/webm" />
              <source src={imagery.video} type="video/mp4" />
              Seu navegador não consegue reproduzir este vídeo.
            </video>
            <div className="video-file-badge"><FileText size={14} /> MP4 · VÍDEO ORIGINAL</div>
          </div>
          <p className="video-caption">Vídeo MP4 enviado pelo responsável · narração em português e texto nos slides. O acesso à página final do livro continua protegido pelo pagamento aprovado.</p>
        </Reveal>
      </div>
    </section>
  );
}
